import {ReactComponent} from "../../app"
import {Button, Image, Skeleton} from "antd"
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons"

import imageCloseSVG from '../../gfx/close.svg'
import dayjs from "dayjs"
import "dayjs/locale/cs"
import BottomSheet from "../layout/BottomSheet"

dayjs.locale("cs")

export default class RewardItemDetail extends ReactComponent {
  state = {
    appliedRewards: true
  }

  render () {
    const activeReward = this.props.type === "active" ? 'Aktivní odměna' : this.state.appliedRewards ? 'Využitá odměna' : 'Nevyužitá odměna'

    return (
      <>
        <BottomSheet
          active={this.props.active}
          onClose={this.props.close}
          iconClose={imageCloseSVG}
          overlay={true}
          cardClassName={this.props.type === "active" ? "" : "reward-item-applied"}
          cover={this.props.reward?.reward.image_urls.length ? (
            <Image preview={false} src={this.props.reward?.reward.image_urls[0]}/>
          ) : (
            <Skeleton.Image/>
          )}
          title={
            <>
              <h3>{this.props.reward?.reward.name}</h3>
              <h6>{this.props.reward?.reward.subtitle}</h6>
            </>
          }
          content={
            <>
              <div>
                {this.props.type === "active" || this.state.appliedRewards ? <CheckCircleFilled/> : <CloseCircleFilled/>}
                <span className='reward-text'>{activeReward}</span>
              </div>

              <div className="mt-03">Platnost do:
                <span className='reward-text pl-02'>{dayjs(this.props.reward?.valid_to).format("D. M. YYYY")}</span>
              </div>

              {this.props.type === "active" &&
                <div className="ta-center mt-4">
                  <Button
                    type="primary"
                  >Využít odměnu</Button>

                  <div className="ta-center mt-2 mb-2 grey pl-2 pr-2">
                    Odměnu aktivujete před personálem, jinak nebude platná.
                  </div>
                </div>
              }
            </>
          }/>
      </>
    )
  }
}